<div class="form-section table" [formGroup]="addruleGroup">
    <div class="rule-title">{{ title }}</div>
    <div class="flex-outer flex-column table">
        <div class="flex-row header">
            <div class="flex-col" *ngFor="let ruleField of rulesFields; let index = index;"
                [ngClass]="{'medium-col': index==0}">
                {{ ruleField }}
            </div>
            <div class="flex-col modify-icons"></div>
        </div>
        <div class="flex-row content" *ngFor="let rule of rules.controls; let index = index;" formArrayName="rules">
            <div class="flex-row-inner" [formGroupName]="index">
                <div class="flex-col medium-col">
                    <mat-select formControlName="metric">
                        <mat-option *ngFor="let option of metricOptions" [value]="option">
                            {{ languageService.languageJSON["StartRollout_RuleMetric_" + option]}}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="flex-col">
                    <mat-select formControlName="comparator">
                        <mat-option *ngFor="let option of comparatorOptions" [value]="option">{{ option }}</mat-option>
                    </mat-select>
                </div>
                <div class="flex-col">
                    <input type="number" appInputLength NumberInput formControlName="threshold"> %
                </div>
                <div class="flex-col">
                    <input type="number" appInputLength NumberInput formControlName="interval"> day
                </div>
                <div class="flex-col modify-icons">
                    <div class="icon-outer">
                        <img src="assets/icons/delete.svg" (click)="removeRule(index)" />
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-row content" *ngIf="rules.controls.length==0">
            <div class="flex-col">{{ languageService.languageJSON.StartApprovalRollout_NoRule }}</div>
        </div>
        <div class="flex-row content" *ngIf="rules.errors?.['duplicate']">
            <div class="flex-col error">{{ languageService.languageJSON.StartApprovalRollout_DuplicatedErrorRule }}
            </div>
        </div>
    </div>
    <div class="add-rule" (click)="addRule()">
        <div class="plus-icon">+</div>
        {{ languageService.languageJSON.StartApprovalRollout_AddRule }}
    </div>
</div>